import { render, staticRenderFns } from "./ModalSupplierPayments.vue?vue&type=template&id=6fc2a34e&lang=pug&"
import script from "./ModalSupplierPayments.vue?vue&type=script&lang=js&"
export * from "./ModalSupplierPayments.vue?vue&type=script&lang=js&"
import style0 from "./ModalSupplierPayments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports